import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/home/index.vue';
import MobileHome from '../views/home/m/index.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/m-preview',
      name: 'm-preview',
      component: MobileHome,
    },
  ],
});

export default router;
